{
  "title": "如何用「自動平均分配」建立評審指派",
  "description": "依評審目前工作量與類別，一次為已送出的作品建議並建立平均的評審指派。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，已送出的作品會依指定的每件評審人數平均分配給評審，並自動略過利益衝突與已存在的指派。",
  "roleNote": "競賽管理員／具指派管理權限的工作人員",
  "prerequisites": [
    "已邀請並有至少一位評審",
    "已建立評分規準",
    "有狀態為「已提交」或「已鎖定」的作品"
  ],
  "pathLabel": "主辦方後台 → 我的競賽 → 審查 → 評審 → 作品指派 → 自動平均分配",
  "steps": [
    {
      "title": "1. 選擇條件",
      "description": "在「作品指派」分頁最上方的「自動平均分配」，選擇賽程輪次（多輪競賽才需要選）、評分規準，並填「每件作品的評審人數」（1 到 10）。"
    },
    {
      "title": "2. 預覽分配",
      "description": "按「預覽分配」。畫面會顯示預計建立幾筆指派、涵蓋幾件作品，以及每位評審「目前 + 新增」的工作量。預覽不會建立任何指派；變更任何條件都會作廢預覽。"
    },
    {
      "title": "3. 檢查缺口",
      "description": "若有作品因可用評審不足（利益衝突或評審人數不夠）而無法達到目標人數，畫面會提示件數。請另外邀請評審，或事後在同一頁手動指派。"
    },
    {
      "title": "4. 確認並建立",
      "description": "按「套用分配」，在確認對話框再次確認後才會建立。建立時系統逐筆再次檢查評審角色、利益衝突與重複，並各記一筆稽核；完成後顯示建立幾筆、略過幾筆。"
    }
  ],
  "afterward": [
    "新的指派出現在各評審的任務清單",
    "評審會在約 10 分鐘後收到一封彙整的新指派通知",
    "已存在的指派與有利益衝突的組合不會被重複建立或強制指派"
  ],
  "nextSteps": "可在「審查進度」頁追蹤各評審的完成狀況，並使用「提醒評審完成評分」。",
  "faq": [
    {
      "q": "分配的依據是什麼？",
      "a": "依評審目前的總工作量（越少越先分配），負載相同時，專長與類別名稱相符的評審優先（專長是評審自填的文字，只是次要依據），其次看該類別內的工作量讓每位評審接觸到不同類別，最後以固定順序打破平手，所以同樣條件會得到同樣結果。"
    },
    {
      "q": "已經手動指派過的作品會被重複指派嗎？",
      "a": "不會。系統只補足缺少的人數，已存在的指派會被計入，且同一評審不會被分到同一件作品兩次。"
    },
    {
      "q": "套用後想調整某一筆怎麼辦？",
      "a": "可在「作品指派」分頁逐筆修改評審或評分規準，或取消單一指派。"
    }
  ]
}
